module.exports = __webpack_public_path__ + "static/media/frames-for-detective.6e162ed4.png";